<template>
  <div class="nav-bar">
    <!-- <div class="ele-icon">
      <p>
        <svg class="icon">
          <use xlink:href="#icon-a-ziyuan2"></use>
        </svg>
        <span>瑞维全景DCIM平台</span>
      </p>
    </div> -->
    <div class="top-right">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        menu-trigger="hover"
        text-color="#fff"
        active-text-color="#132A55"
      >
        <el-submenu index="2">
          <template slot="title">
            {{ userName }}
          </template>
          <!-- <el-menu-item
            index="2-1"
            style="
              height: 40px;
              text-align: center;
              line-height: 40px;
              color: #000;
            "
            @click="changeAuth"
            >切换角色</el-menu-item
          >
          <el-menu-item
            index="2-2"
            style="
              height: 40px;
              text-align: center;
              line-height: 40px;
              color: #000;
            "
            @click="changePass"
            >修改密码</el-menu-item
          > -->
          <el-menu-item
            index="2-3"
            style="
              height: 40px;
              text-align: center;
              line-height: 40px;
              color: #000;
            "
            @click="loginOut"
            >退出</el-menu-item
          >
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { logout } from '@/api/login';
export default {
  data() {
    return {
      activeIndex: '2',
      elIcon: 'el-icon-s-fold',
      allowShowAside: true,
      userName: '用户管理员',
    };
  },
  created() {},
  mounted() {},
  methods: {
    showAside() {
      this.allowShowAside = !this.allowShowAside;
      if (this.allowShowAside) {
        this.elIcon = 'el-icon-s-fold';
      } else {
        this.elIcon = 'el-icon-s-unfold';
      }
      this.$store.commit('allowAside');
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    loginOut() {
      this.$myConfirm
        .showMsgBox({
          title: '提示',
          tips: '',
          content: '确定退出登录吗？',
        })
        .then(() => {
          // window.location.reload();
          localStorage.removeItem('token');
          window.location.href =
            window.location.href.split('#')[0] + '#' + '/login';
        })
        .catch((error) => {
          console.log(error);
        });
    },
    changePass() {},
  },
  components: {},
};
</script>
<style lang="scss" scoped>
::v-deep .el-submenu__title {
  color: #000 !important;
}
::v-deep .el-menu-item {
  color: #000 !important;
}
.nav-bar {
  width: 100%;
  height: 50px;

  .ele-icon {
    float: left;
    padding-left: 20px;
    svg {
      stroke: whitesmoke;
      stroke-width: 11;
      height: 50px;
      width: 79px;
      stroke-linecap: 'butt';
      margin-top: 1px;
    }
    span {
      position: absolute;
      font-size: 22px;
      line-height: 50px;
      color: #fff;
      font-weight: bold;
      padding-left: 15px;
    }
  }
  .top-right {
    display: flex;
    align-items: center;
    position: relative;
    line-height: 50px;
    height: 50px;
    float: right;
    .username {
      color: #000;
      margin-left: 10px;
      margin-right: 20px;
    }

    .el-menu-item {
      line-height: 50px;
      text-align: center;
    }
    .el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
      margin-top: 5px;
    }
    .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
      border: none;
    }
    .el-menu--horizontal .el-menu .el-menu-item,
    .el-menu--horizontal .el-menu .el-submenu__title {
      line-height: 40px;
      height: 40px;
    }
    .el-menu,
    .el-menu--popup,
    .el-menu--popup-bottom-start {
      min-width: 160px !important;
    }
    .el-menu--popup-bottom-start {
      margin-top: 5px;
    }
  }
}
</style>
